const StripeWarning = () => {
    return (
        <p className="small text-muted mt-4">Buying a product will end this session. You will need to restart the project creation process after the transaction.</p>
    );
}
export default StripeWarning;